import { render, staticRenderFns } from "./CategoryGiroMin.vue?vue&type=template&id=67ccd24a"
import script from "./CategoryGiroMin.vue?vue&type=script&lang=js"
export * from "./CategoryGiroMin.vue?vue&type=script&lang=js"
import style0 from "./CategoryGiroMin.vue?vue&type=style&index=0&id=67ccd24a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports